import { RouteEntry } from "../../shared/routes";
import { IdentityRoles } from "../../configure/security/IdentityRoles";
import { DepartmentQuestionnairesHome } from "./DepartmentQuestionnairesHome";

export const departmentQuestionnairesRoutes: Array<RouteEntry> = [
    { path: '/departmentQuestionnaires', exact: true, component: DepartmentQuestionnairesHome, authorize: true, requireRole: IdentityRoles.SubscriptionDepartmentAdministration },
];

